module.exports = __webpack_public_path__ + "static/media/13.50b0b10e.jpg";